import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { Invoice } from '@/views/my-projects/components/invoices/fakeData';
import BCXFormValues from '@/components/molecules/forms/BCXFormValues.vue';
import { BcxFormValueField } from '@/models/BcxForm';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import useI18n from '@/mixins/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceIncomingExtendedRowBaseData',
  props: {
  invoice: {
    type: Object as PropType<Invoice>,
    default: null
  }
},
  setup(__props) {

const props = __props;




const { isNarrow } = useMyProjects();
const { t } = useI18n();

const fields = computed(() => {
  const f = {
    status: { name: 'status', label: `${t('invoices.extended-row.invoice.status')}` },
    bcId: { name: 'bcId', label: `${t('invoices.extended-row.invoice.bytecookieId')}` },
    invoiceDate: { name: 'invoiceDate', label: `${t('invoices.extended-row.invoice.invoiceDate')}` },
    invoiceNr: { name: 'invoiceNr', label: `${t('invoices.extended-row.invoice.invoiceNr')}` },
    due: { name: 'due', label: `${t('invoices.extended-row.invoice.due')}` },
    costCenter: { name: 'costCenter', label: `${t('invoices.extended-row.invoice.costCenter')}` },
    amount: { name: 'amount', label: `${t('invoices.extended-row.invoice.amount')}` },
    contractId: { name: 'contractId', label: `${t('invoices.extended-row.invoice.contractId')}` },
    reference: { name: 'reference', label: `${t('invoices.extended-row.invoice.reference')}` },
  };
  const fields:BcxFormValueField[] = isNarrow.value ? [
    // mobile order:
    { ...f.status, width: '50%' },
    { ...f.bcId, width: '50%' },

    { ...f.invoiceDate, width: '50%' },
    { ...f.invoiceNr, width: '50%' },

    { ...f.due, width: '50%' },
    { ...f.costCenter, width: '50%' },

    { ...f.amount, width: '50%' },
    { ...f.contractId, width: '50%' },

    { ...f.reference, width: '100%' }
  ] : [
    // desktop order:
    { ...f.status, width: '25%' },
    { ...f.bcId, width: '25%' },
    { ...f.due, width: '50%' },

    { ...f.amount, width: '25%' },
    { ...f.invoiceDate, width: '25%' },
    { ...f.invoiceNr, width: '25%' },
    { ...f.costCenter, width: '25%' },

    { ...f.contractId, width: '25%' },
    { ...f.reference, width: '75%' }
  ];
  return fields;
});

const data = computed(() => ({
  status: props.invoice.status,
  bcId: 'R.1234.XGH.2002',
  due: props.invoice.due,
  amount: '23.350,00 €',
  invoiceDate: '2021-01-01',
  invoiceNr: 'R.1234.GERF.2021.0001.SGSERFSERFSREF',
  costCenter: props.invoice.costCenter,
  contractId: 'Vertrag 1234',
  reference: props.invoice.reference,
}));


return { __sfc: true,props, isNarrow, t, fields, data, BCXFormValues }
}

})